import { Link, useSearchParams } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { days } from 'utils/days';
import { toUpper } from 'utils/toUpper';
import { Datestamp } from './Datestamp';
import { Description } from './Description';
import { Modified } from './Modified';
import { Name } from './Name';
import { Tag } from './Tag';
import { Tags } from './Tags';

const StyledBody = createGlobalStyle`
  .body-class {
    background-color: ${({ theme }) => theme.color.additional.light.value};
  }
`;

export const ExamplesList = styled(({ className, list }) => {
  const [searchParams] = useSearchParams();
  const tags = searchParams.get('tags');
  const activeTags = tags !== null ? tags?.split(',') : [];

  return (
    <div className={className}>
      <ul>
        {list.map((example) => (
          <li key={`example ${example.path}`}>
            <div>
              <Name className="ExamplesList">
                <Link to={example.path} state={{ from: 'index' }}>
                  {example.name}
                </Link>
              </Name>
              <Description>{example.description}</Description>
            </div>
            <Tags>
              {toUpper(example?.tags)
                .sort()
                .map((tag, index) => {
                  return <Tag key={`${index} ${tag}`} active={activeTags?.includes(tag.toLowerCase())} tag={tag} />;
                })}
            </Tags>
            <Datestamp>{days(example?.created.match(/(.*, \d*)/)[1])}</Datestamp>
            <Modified>{days(example?.modified)}</Modified>
          </li>
        ))}
      </ul>
      <StyledBody />
    </div>
  );
})`
  p {
    margin: 0;
    font-size: 14px;
    color: ${({ theme }) => theme.color.gray[600].value};
    padding-bottom: 8px;
    a,
    a:visited {
      text-decoration: none;
      color: ${({ theme }) => theme.color.primary[500].value};
      border-bottom: 1px solid transparent;
      padding-bottom: 1px;
    }
    a:hover {
      border-bottom-color: ${({ theme }) => theme.color.primary[600].value};
      color: ${({ theme }) => theme.color.primary[600].value};
    }
  }
  ul {
    margin-left: 0;
    padding-left: 0;
    list-style-type: none;
  }
  li {
    margin: 16px 0;
    padding: 0;
    display: grid;
    grid-template-columns: calc(56% - 48px) 24% 10% 10%;
    gap: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.color.gray[400].value};
  }
`;
